import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ConfigurationService } from '../../services/configuration.service';

@Injectable({
  providedIn: 'root'
})
export class OfflineGuard  {

  constructor(private router: Router, private configService: ConfigurationService) {}

  canActivate(): boolean {
    if (!this.configService.isOnline) {
      this.router.navigate(['/networkerrorpage']);
      return false;
    }
    return true;
  }
  
}
